import { useUser } from './useUser';

export interface TeamMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  organizationId: string;
  firebaseAuthId?: string;
  bio?: string;
  photoUrl?: string;
  slug?: string;
}

export const useTeamMember = () => {
  const { user, loading, error } = useUser();

  const teamMember: TeamMember | null = user
    ? {
        id: user.id,
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        email: user.email,
        phoneNumber: user.phoneNumber || '',
        organizationId: user.organizationId,
        photoUrl: user.photoURL,
        bio: user.bio,
        slug: user.slug,
      }
    : null;

  return {
    teamMember,
    teamMemberId: user?.id ?? null,
    loading,
    error,
  };
};

export default useTeamMember;
